module.exports = __webpack_public_path__ + "img/node-meta.2801d3ad.png";